import React from 'react';
import { Typography } from '@mui/material';
import { Icon, Popup } from '@elements';
import { StyledContent, StyledHeader } from './error.styles';
import error from '@images/error.svg';
/**
 * ErrorPopup component.
 *
 * @author Mikhail Siutsou
 * @function ErrorPopup
 * @category components
 * @param {PopupProps} popup props.
 * @return {FC} popup component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ErrorPopup = function ErrorPopup(_ref) {
  var rejectPopup = _ref.rejectPopup,
      popUp = _ref.popUp;
  var header = popUp && popUp.data && popUp.data.header;
  var body = popUp && popUp.data && popUp.data.body;
  return /*#__PURE__*/_jsxs(Popup, {
    width: 422,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(Icon, {
          src: error,
          width: 60,
          height: 60
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(StyledContent, {
        flexDirection: "column",
        children: [header && /*#__PURE__*/_jsx(Typography, {
          color: "mineshaft",
          variant: "body1",
          fontWeight: 700,
          textAlign: "center",
          children: header
        }), body && /*#__PURE__*/_jsx(Typography, {
          color: "raven",
          textAlign: "center",
          variant: "body2",
          sx: {
            wordBreak: 'break-word'
          },
          pt: header ? 2 : undefined,
          children: body
        })]
      })
    })]
  });
};

export { ErrorPopup };